import React, { useState } from "react"
import { Link, graphql } from "gatsby"
import { motion } from "framer-motion"
import kebabCase from "lodash/kebabCase"
import Layout from "../components/layout"
import Posts from "../components/Blog/Posts"
import SEO from "../components/seo"
import {ArrowDown} from "../components/icons/arrow-down-icon"

function FadeInWhenVisible({ children }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      {children}
    </motion.div>
  )
}

const BlogPage = ({ data, location }) => {
  const siteUrl = data.site.siteMetadata.canonicalUrl
  const allArticles = data.posts.edges
  const allTags = data.tags.group
  const emptyQuery = ""
  const [searchState, setSearchState] = useState({
    filteredData: [],
    query: emptyQuery,
  })
  const { filteredData, query } = searchState
  const hasSearchResults = filteredData && query !== emptyQuery
  const posts = hasSearchResults ? filteredData : allArticles

  const filteredTags = allTags.filter( (tag, idx) => 
    idx === allTags.findIndex( uniqueTag => 
      uniqueTag.fieldValue === tag.fieldValue && uniqueTag.id === tag.id
  ))
  
  const handleSearch = (e) => {
    const query = e.target.value
    const allArticles = data.posts.edges || []

    const filteredData = allArticles.filter(post => {
      const { title, description, tags } = post.node.frontmatter
      return (
        description.toLowerCase().includes(query.toLowerCase()) ||
        title.toLowerCase().includes(query.toLowerCase()) ||
        (tags &&
          tags
            .join("")
            .toLowerCase()
            .includes(query.toLowerCase()))
      )
    })
    setSearchState({
      query,
      filteredData,
    })
  }
  const filterTags = (tag) => {
    const query = tag.toLowerCase()
    const allArticles = data.posts.edges || []

    const filteredData = allArticles.filter(post => {
      const { title, description, tags } = post.node.frontmatter
      return (
        description.toLowerCase().includes(query.toLowerCase()) ||
        title.toLowerCase().includes(query.toLowerCase()) ||
        (tags &&
          tags
            .join("")
            .toLowerCase()
            .includes(query.toLowerCase()))
      )
    })
    setSearchState({
      query,
      filteredData,
    })
  }
  const clearResults = () => {
    const queryData = ""
    setSearchState({
      query: queryData,
      filteredData: [],
    })
  }
  return (
    <Layout>
      <SEO 
        title="The Danniel Hansel Blog" 
        description="I write about my life experiences, React, web development and problems that I solved. Enjoy your read." 
        keywords={["Danniel Hansel blog", "JavaScript", "React", "Tailwind CSS", "Career", "Development", "Life", "Software Development", "Software Engineering"]}
        url={`${siteUrl}${location.pathname}`} />
      <div className="flex justify-center items-center bg-gradient-to-br from-purple-200 via-indigo-300 to-teal-300 dark:from-gray-700 dark:via-gray-900 dark:to-black background-animate mb-20">
        <div className="overflow-x-hidden">
          <div className="container mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 place-items-center gap-4 h-screen">
              <div className="">
                <div className="block lg:hidden relative w-full max-w-lg">
                  <div className="absolute top-0 -left-4 w-64 h-64 bg-purple-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob "></div>
                  <div className="absolute top-0 -right-4 w-64 h-64 bg-yellow-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
                  <div className="absolute -bottom-8 left-20 w-64 h-64 bg-pink-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
                  <div className="mx-auto rounded-full relative w-60 h-60 hover:scale-125 hover:z-10 transform ease-in-out transition duration-500 ">
                    {/* <img src={frontmatter.profileUrl} className="object-cover md:object-scale-down h-full w-full rounded-full ring ring-accent ring-offset-4 ring-offset-transparent" alt={frontmatter.author} /> */}
                  </div>
                </div>
                <header className="px-4">
                  <FadeInWhenVisible>
                    <h1 className="font-body2 mt-20 lg:mt-0 font-medium text-3xl lg:text-5xl text-quarternary text-start">
                      Blog
                    </h1>
                    <h2 className="font-medium text-3xl lg:text-5xl text-secondary-text text-start mt-6">
                      I write about React, web development, problems that I solved and notes for my future self. Enjoy your read.
                    </h2>
                  </FadeInWhenVisible>
                  <div 
                    className="hidden md:flex items-center justify-start text-secondary-text hover:text-quarternary pt-12"
                    // onClick={() => { navigate("/#about")}}
                    >
                      <Link to="#searchBlog" aria-label="read more about Danniel Hansel">
                        <button class="flex flex-cols-2 space-x-6 items-center justify-center">
                          <ArrowDown />
                          <span className="font-body2 relative text-2xl font-semibold leading-relaxed tracking-tight ">Read my blogs</span>
                        </button>
                      </Link>
                      
                  </div>
                </header>
              </div>
              <div className="hidden lg:block ">
                <div className="relative w-full max-w-lg">
                    <div className="absolute top-0 -left-20 w-96 h-96 bg-purple-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob "></div>
                    <div className="absolute top-0 -right-4 w-96 h-96 bg-yellow-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
                    <div className="absolute -bottom-8 left-20 w-96 h-96 bg-pink-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
                    <div className="mx-auto rounded-full relative w-80 h-80 hover:scale-125 hover:z-10 transform ease-in-out transition duration-500 ">
                    {/* <img src={frontmatter.profileUrl} className="object-cover h-full w-full rounded-full ring ring-accent ring-offset-4 ring-offset-transparent"alt={frontmatter.author} /> */}
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <section id="searchBlog" className="container mx-auto scroll-mt-32 lg:scroll-mt-36">
        <div className="w-full md:w-3/4 lg:w-1/2 h-12 pl-3 pr-2 bg-tertiary rounded-full flex justify-center items-center relative mx-auto">
          <span  className="mx-3 outline-none focus:outline-none active:outline-none">
            <svg 
              fill="none"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24" 
              className="stroke-current w-6 h-6">
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </span>
          <input 
            type="text" 
            name="search" 
            id="search" 
            aria-label="Search"
            placeholder="Type to filter posts..."
            onChange={handleSearch}
            className="placeholder:italic placeholder:text-gray-400 block bg-tertiary w-full border border-tertiary rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-accent focus:ring-accent focus:ring-1 sm:text-sm"/>
          
        </div>
          <p className="font-medium text-md md:text-lg lg:text-xl text-secondary-text text-start mt-12 px-4">Search by topics</p>
        <div className="flex flex-wrap space-4 justify-start mt-4">
          <button onClick={() => clearResults()} className="w-20 text-lg font-bold m-2 border-2 border-transparent hover:border-quarternary rounded-full bg-tertiary justify-center text-center py-2 px-6">
            all
          </button>
          {filteredTags.map((tag) => 
            <Link to="#allBlogs">
              <button 
              key={tag.fieldValue}
              onClick={() => filterTags(tag.fieldValue)} 
              className="text-lg font-bold m-2 border-2 border-transparent hover:border-quarternary active:border-quarternary focus:border-quarternary rounded-full bg-tertiary justify-center text-center py-2 px-6">
                {kebabCase(tag.fieldValue)}
            </button>
            </Link>
            
          )}

        </div>
      </section>
      {/* <FeaturedPosts cta={false} content={data.featured.edges} /> */}
      <section id="allBlogs" className="container mx-auto mt-16 scroll-mt-32 lg:scroll-mt-36">
        {/* <Posts content={data.posts.edges} /> */}
        {/* <Posts content={allArticles} /> */}
        <ol className="mt-4 grid grid-cols-1 lg:grid-cols-3 gap-x-4">
          {/* <FadeInWhenVisible> */}
            {posts.map(article => <Posts content={article.node} />)}
          {/* </FadeInWhenVisible> */}
        </ol>
      </section>
    </Layout>
  )
}
export const query = graphql`
  {
    site {
      siteMetadata {
        title
        description
        canonicalUrl
        image
        author {
          name
        }
        organization {
          name
          url
          logo
        }
        social {
          twitter
        }
      }
    }
    posts: allMdx(
      filter: {
        fileAbsolutePath: { regex: "/content/blog/" }
        frontmatter: { published: { eq: true } }
      }
      sort: { order: DESC, fields: frontmatter___date }
    ) {
      edges {
        node {
          fields {
            slug
          }
          body
          timeToRead
          frontmatter {
            slug
            title
            categories
            tags
            description
            bannerUrl
            date(formatString: "MMMM DD, YYYY")
          }
          id
          excerpt(pruneLength: 100)
        }
      }
    }
    tags: allMdx(
      sort: {fields: frontmatter___date, order: DESC}
      filter: {fileAbsolutePath: {regex: "/content/blog/"}}
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`
export default BlogPage
